const OPEN_CONFIRM = "confirmBox/OPEN_CONFIRM";
const CLOSE_CONFIRM = "confirmBox/CLOSE_CONFIRM";

export function openConfirm({ title, description, callback, isAlert, okBtnText, cancelBtnText, maxWidth = false, fullWidth = false, buttons }) {
  return { type: OPEN_CONFIRM, config: { title, description, callback, isAlert, okBtnText, cancelBtnText, maxWidth, fullWidth, buttons } };
};

export function okConfirm(callback = () => { }) {
  callback.call();
  return { type: CLOSE_CONFIRM };
};

export function cancelConfirm() {
  return { type: CLOSE_CONFIRM };
};

const defaultState = {
  isOpen: false,
  config: {
    title: null,
    description: null,
    callback: () => { },
    isAlert: false,
    okBtnText: null,
    cancelBtnText: null,
    maxWidth: false,
    fullWidth: false
  }
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case OPEN_CONFIRM:
      return { ...state, isOpen: true, config: action.config };
    case CLOSE_CONFIRM:
      return { ...state, isOpen: false };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/components/confirmBox/confirmBox.duck.js